import React, { useCallback, useMemo } from 'react';

import i18n from '@nextroll/ar-i18n';

import { useRoflStore } from 'store/roflStore';

import { NodePanelDropDown } from '../../../basic/NodePanelDropDown/NodePanelDropDown';
import { TriggerRuleType, TriggerRuleTypeOption } from '../ContactTriggerNode.type';
import { CONTACT_TRIGGER_ERROR } from '../ContactTriggerNode.constant';


interface IProps {
    triggerNodeType?: TriggerRuleType;
    onUpdateTriggerNodeType?: (triggerNodeType: TriggerRuleType) => void;
    data?: TriggerRuleTypeOption[];
    error?: string;
}

export const ContactTriggerNodeTypeSection = (props: IProps) => {
    const { triggerNodeType, onUpdateTriggerNodeType, data, error } = props;

    const shouldShowRequiredError = useRoflStore(state => state.shouldShowRequiredError);

    const errorDisplayed = useMemo(() => {
        if (error) {
            return error;
        }
        if (shouldShowRequiredError && !triggerNodeType) {
            return CONTACT_TRIGGER_ERROR.UNSELECTED_TYPE;
        }
    }, [error, shouldShowRequiredError, triggerNodeType]);

    const handleSelectOption = useCallback(
        (option: TriggerRuleTypeOption) => onUpdateTriggerNodeType?.(option.type),
        [onUpdateTriggerNodeType],
    );

    return (
        <div className='workflow-contact-trigger-node-panel-type' data-testid='trigger-type-selector'>
            <NodePanelDropDown<TriggerRuleTypeOption>
                data={data}
                error={errorDisplayed}
                onSelect={handleSelectOption}
                renderOption={option => option.label}
                renderTooltip={option => option.tooltip}
                renderSelected={option => option.type === triggerNodeType}
                label={i18n.gettext('Trigger Type')}
                placeholder={i18n.gettext('Select Trigger Type')}
            />
        </div>
    );
};
